// extracted by mini-css-extract-plugin
export default {"melodyVideo":"OM-z","isFullWidth":"PM-z","landingPageVideo":"QM-z","play":"RM-z","iframeVideo":"SM-z","playHidden":"TM-z","fullwidth":"UM-z"};